import { Alert, Grid2 as Grid, Icon, IconButton, ListItemText, Paper, Skeleton } from "@mui/material"
import { handleRetrieveDocs } from "../../../../../redux/specialist-slices/my-member.slice"
import TablePagination from "../../../../../components/common/TablePagination"
import { FILE_PATH_URI, handleDownload } from "../../../../../utils/helper"
import { useDispatch, useSelector } from "react-redux"
import Icons from "../../../../../assets/js/Icons"
import { useEffect, useState } from "react"
import moment from "moment"

function Documents({ memberId }) {
  const dispatch = useDispatch()
  const { loadings } = useSelector((s) => s.otherSlice)

  const [data, setData] = useState({})

  const handleRetrieveAll = async (filters) => {
    const response = await dispatch(
      handleRetrieveDocs({
        limit: 10,
        id: memberId,
        currentPage: filters?.currentPage || null,
      })
    ).unwrap() || {}
    if (response?.records)
      setData(response)
  }

  useEffect(() => {
    if (memberId) {
      handleRetrieveAll({ currentPage: 1 })
    }
    // eslint-disable-next-line
  }, [memberId])


  return (
    <>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {loadings?.retrieveAll ?
          new Array(5).fill().map((_, i) => (
            <Grid size={{ xs: 6, md: 12 / 5, xl: 2 }} key={i}>
              <Skeleton sx={{ width: "100%", height: 150, transform: "none" }} />
            </Grid>
          )) :
          !Boolean(data?.records?.length) ?
            <Grid size={12}>
              <Alert severity="info">
                No documents uploaded by this member yet.
              </Alert>
            </Grid> :
            data?.records?.map((element, i) => (
              <Grid size={{ xs: 6, md: 12 / 5, xl: 2 }} key={i}>
                <Paper paperVariant="documentViewA">
                  <Icon sx={{ fontSize: 100, m: "auto", "svg": { display: "block" } }}>
                    <Icons.ForumAll />
                  </Icon>
                  <ListItemText
                    primary={element?.file?.originalName}
                    secondary={moment(element.createdAt).format("ddd MMM DD • h:mm A")}
                    slotProps={{
                      primary: {
                        style: { fontSize: 14 },
                        title: element?.file?.originalName
                      },
                      secondary: {
                        style: { fontSize: 12 },
                        title: moment(element.createdAt).format("ddd MMM DD • h:mm A")
                      },
                    }}
                  />
                  <IconButton
                    size="small"
                    variant="dialogCloseBtn"
                    sx={{ color: "primary.main" }}
                    onClick={() => handleDownload(FILE_PATH_URI + element?.path)}
                  ><Icons.CloudDownloadSolid />
                  </IconButton>
                </Paper>
              </Grid>
            ))
        }
      </Grid>

      <TablePagination
        color="primary"
        cb={handleRetrieveAll}
        length={data?.records?.length}
        pagination={data?.pagination}
        loading={loadings?.retrieveAll}
      />
    </>
  )
}

export default Documents